import { render, staticRenderFns } from "./BancoModal.vue?vue&type=template&id=52b98959&scoped=true&"
import script from "./BancoModal.vue?vue&type=script&lang=js&"
export * from "./BancoModal.vue?vue&type=script&lang=js&"
import style0 from "./BancoModal.vue?vue&type=style&index=0&id=52b98959&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "52b98959",
  null
  
)

export default component.exports